import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { HeartHandshake, Wheat, BadgePercent, Phone } from "lucide-react";
import { SectionHead, Reveal } from "./Reveal";
import { useLang } from "../../lib/lang";

const ICONS = [HeartHandshake, Wheat, BadgePercent, Phone];

export const WhyUs = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], [60, -60]);
  const y2 = useTransform(scrollYProgress, [0, 1], [-30, 50]);
  return (
    <section ref={ref} id="why" data-testid="why-section" className="relative overflow-hidden bg-[#A9493B] py-24 lg:py-36">
      <div className="pattern-overlay absolute inset-0 opacity-[0.07]" />
      <div className="relative mx-auto grid max-w-[1400px] grid-cols-12 items-center gap-y-16 px-5 lg:gap-x-16 lg:px-10">
        <div className="relative col-span-12 h-[440px] sm:h-[560px] lg:col-span-6">
          <motion.div style={{ y: y1 }} className="arch absolute left-0 top-0 h-[85%] w-[62%] overflow-hidden shadow-2xl">
            <img src="/dish/o-mix-lg.webp" alt="Mix Tallrik" className="h-full w-full scale-110 object-cover" />
          </motion.div>
          <motion.div style={{ y: y2 }} className="arch absolute bottom-0 right-0 h-[62%] w-[48%] overflow-hidden border-[6px] border-white shadow-2xl">
            <img src="/food/half-meny.webp" alt="Halv kyckling meny" className="h-full w-full object-cover" />
          </motion.div>
        </div>
        <div className="col-span-12 lg:col-span-6">
          <SectionHead light eyebrow={t.why.eyebrow} title={t.why.title} titleEm={t.why.titleEm} />
          <div className="mt-12 grid gap-x-8 gap-y-10 sm:grid-cols-2">
            {t.why.items.map((it, i) => {
              const Icon = ICONS[i];
              return (
                <Reveal key={it.title} delay={i * 0.08} data-testid={`why-item-${i}`}>
                  <Icon className="text-[#E9C46A]" size={26} strokeWidth={1.5} />
                  <h3 className="font-display mt-4 text-2xl text-white">{it.title}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-white/85">{it.desc}</p>
                </Reveal>
              );
            })}
          </div>
          <Reveal className="mt-14 grid grid-cols-3 border-t border-white/20 pt-8">
            {t.why.stats.map((s) => (
              <div key={s.l}>
                <p className="font-display text-4xl text-[#E9C46A] sm:text-5xl">{s.v}</p>
                <p className="mt-1 text-xs uppercase tracking-[0.16em] text-white/80">{s.l}</p>
              </div>
            ))}
          </Reveal>
        </div>
      </div>
    </section>
  );
};
